import { useCallback } from 'react';
import { DirectoryUsersGrid } from '@jarvis/platform-ui';
import { fetchCompanyEmployeesSyncStatus, listCompanyEmployees } from '../../api/directoryUsers';

export function CompanyEmployeesPage() {
  const loadPage = useCallback(
    (request: Parameters<typeof listCompanyEmployees>[0]) => listCompanyEmployees(request),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <DirectoryUsersGrid
          loadPage={loadPage}
          loadSyncStatus={fetchCompanyEmployeesSyncStatus}
          stateStorageKey="webopsui:company-employees-grid:v6"
        />
      </div>
    </div>
  );
}
